import React, { useState, useEffect } from 'react';
import { InfoCircleTwoTone } from '@ant-design/icons';
import PropTypes from 'prop-types';
import {
  AutoComplete, Button, Checkbox, Col, DatePicker,
  Input, InputNumber, Row, Select, Form,
  Tooltip, notification,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import locale from 'antd/lib/date-picker/locale/pt_BR';
import moment from 'moment/moment';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import './FillDetails.scss';
import SelectedLands from '../selectedLands/SelectedLands';
import GeoMapSummary from '../geoMapSummary/GeoMapSummary';

const dateFormat = 'DD/MM/YYYY';

const FillDetails = (props): JSX.Element => {
  const {
    nextPage, params, removeSelectedField, isCurrentPage,
    previousPage,
  } = props;

  const arrIdsCodeEstimateFloat = [
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-VALOR_UNITARIO',
    'SATELITE-TAXA_VARIAVEL_N-VALOR_UNITARIO',
    'SATELITE-MAPA_TCH-VALOR_UNITARIO',
    'SATELITE-LEVANTAMENTO_PRAGAS-VALOR_UNITARIO',
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-VALOR_TOTAL',
    'SATELITE-TAXA_VARIAVEL_N-VALOR_TOTAL',
    'SATELITE-MAPA_TCH-VALOR_TOTAL',
    'SATELITE-LEVANTAMENTO_PRAGAS-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-PASTAGEM-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-LINHA-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-CARRETA-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-PASTAGEM-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-LINHA-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-CARRETA-VALOR_TOTAL',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-VALOR_UNITARIO',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-VALOR_TOTAL',
    'VANT-ORTOMOSAICO-VALOR_UNITARIO',
    'VANT-PROJETO_PLANTIO-VALOR_UNITARIO',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-VALOR_UNITARIO',
    'VANT-MAPEAMENTO_LINHAS-VALOR_UNITARIO',
    'VANT-LEVANTAMENTO_FALHAS-VALOR_UNITARIO',
    'VANT-ZONA_MANEJO-VALOR_UNITARIO',
    'VANT-ORTOMOSAICO-VALOR_TOTAL',
    'VANT-PROJETO_PLANTIO-VALOR_TOTAL',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-VALOR_TOTAL',
    'VANT-MAPEAMENTO_LINHAS-VALOR_TOTAL',
    'VANT-LEVANTAMENTO_FALHAS-VALOR_TOTAL',
    'VANT-SISTEMATIZACAO-VALOR_UNITARIO',
    'VANT-SISTEMATIZACAO-VALOR_TOTAL',
    'VANT-ZONA_MANEJO-VALOR_TOTAL',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-VALOR_UNITARIO',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-VALOR_TOTAL',
  ];

  const arrIdsCodeEstimateString = [
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-CONDICAO_PAGAMENTO',
    'SATELITE-TAXA_VARIAVEL_N-CONDICAO_PAGAMENTO',
    'SATELITE-MAPA_TCH-CONDICAO_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PRAGAS-CONDICAO_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-FORMA_PAGAMENTO',
    'SATELITE-TAXA_VARIAVEL_N-FORMA_PAGAMENTO',
    'SATELITE-MAPA_TCH-FORMA_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PRAGAS-FORMA_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-OBSERVACOES',
    'SATELITE-TAXA_VARIAVEL_N-OBSERVACOES',
    'SATELITE-MAPA_TCH-OBSERVACOES',
    'SATELITE-LEVANTAMENTO_PRAGAS-OBSERVACOES',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-PASTAGEM-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-LINHA-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-CARRETA-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-PASTAGEM-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-LINHA-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-CARRETA-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-OBSERVACOES',
    'APLICACAO_CORRETIVOS-PASTAGEM-OBSERVACOES',
    'APLICACAO_CORRETIVOS-LINHA-OBSERVACOES',
    'APLICACAO_CORRETIVOS-CARRETA-OBSERVACOES',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-CONDICAO_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-FORMA_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-OBSERVACAO',
    'VANT-ORTOMOSAICO-CONDICAO_PAGAMENTO',
    'VANT-PROJETO_PLANTIO-CONDICAO_PAGAMENTO',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-CONDICAO_PAGAMENTO',
    'VANT-MAPEAMENTO_LINHAS-CONDICAO_PAGAMENTO',
    'VANT-LEVANTAMENTO_FALHAS-CONDICAO_PAGAMENTO',
    'VANT-SISTEMATIZACAO-CONDICAO_PAGAMENTO',
    'VANT-ZONA_MANEJO-CONDICAO_PAGAMENTO',
    'VANT-ORTOMOSAICO-FORMA_PAGAMENTO',
    'VANT-PROJETO_PLANTIO-FORMA_PAGAMENTO',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-FORMA_PAGAMENTO',
    'VANT-MAPEAMENTO_LINHAS-FORMA_PAGAMENTO',
    'VANT-LEVANTAMENTO_FALHAS-FORMA_PAGAMENTO',
    'VANT-SISTEMATIZACAO-FORMA_PAGAMENTO',
    'VANT-ZONA_MANEJO-FORMA_PAGAMENTO',
    'VANT-ORTOMOSAICO-OBSERVACOES',
    'VANT-PROJETO_PLANTIO-OBSERVACOES',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-OBSERVACOES',
    'VANT-MAPEAMENTO_LINHAS-OBSERVACOES',
    'VANT-LEVANTAMENTO_FALHAS-OBSERVACOES',
    'VANT-SISTEMATIZACAO-OBSERVACOES',
    'VANT-ZONA_MANEJO-OBSERVACOES',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-CONDICAO_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-FORMA_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-OBSERVACOES',
  ];

  const [formInstance] = Form.useForm();

  const [idFisica, setIdFisica] = useState('');
  const [idRotina, setidRotina] = useState('');
  const [idMicro, setidMicro] = useState('');
  const [idValorUnitario, setIdValorUnitario] = useState('');
  const [idValorTotal, setIdValorTotal] = useState('');
  const [idCondicaoPagamento, setIdCondicaoPagamento] = useState('');
  const [idFormaPagamento, setIdFormaPagamento] = useState('');

  const [allState, setAllState] = useState({});

  const [reordered, setReordered] = useState([]);

  const [reorderedSubtype, setReorderedSubtype] = useState([]);
  const toolTipMessage = 'Terraço curva embutido - Estrutura de conservação de solo que não é possível plantar sobre ele.\nTerraço curva passante - Estrutura de conservação de solo que é possível plantar sobre ele.';

  const reorder = (arrayOfFields): any => {
    const fields = arrayOfFields;

    function insertAt(array, index, a): void {
      array.splice(index, 0, a);
    }

    let newFields = [];

    if (fields.length > 0) {
      newFields = fields.filter((field) => field.conditionFieldId == null);
      newFields.sort((a, b) => a.id > b.id);
      let haveFieldToBeSorted = true;

      while (haveFieldToBeSorted) {
        haveFieldToBeSorted = false;

        for (let iCount = fields.length - 1; iCount >= 0; iCount -= 1) {
          const field = fields[iCount];

          if (field.conditionFieldId != null) {
            const indexDependencyField = newFields
              .filter((field1) => field1.id == field.conditionFieldId);

            if (indexDependencyField.length === 0) {
              haveFieldToBeSorted = true;
            } else if (!newFields.includes(field)) {
              const indexDependencyFieldIndex = newFields
                .indexOf(indexDependencyField[0]);

              insertAt(newFields, indexDependencyFieldIndex + 1, field);
            }
          }
        }
      }
    }
    return newFields;
  };

  const validateLayer20 = (): Promise<void> => {
    const layer020Rotina = formInstance.getFieldValue(`dynamicField${idRotina}`);
    const layer020Micro = formInstance.getFieldValue(`dynamicField${idMicro}`);
    const layer020Fisica = formInstance.getFieldValue(`dynamicField${idFisica}`);

    if (!layer020Rotina && !layer020Micro && !layer020Fisica) {
      return Promise.reject(new Error('Pelo menos um dos campos de amostragem na camada 0-20cm deve estar selecionado'));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    const newOrderedFields = reorder(params.serviceTypeDynamicFields);
    setReordered(newOrderedFields);

    newOrderedFields.forEach((field) => {
      if (field.name === 'Física') {
        setIdFisica(field.id);
      }

      if (field.name === 'Rotina, Alumínio e Enxofre') {
        setidRotina(field.id);
      }

      if (field.name === 'Micro') {
        setidMicro(field.id);
      }

      if (field.name === 'Valor unitário') {
        setIdValorUnitario(field.id);
      }

      if (field.name === 'Valor total') {
        setIdValorTotal(field.id);
      }

      if (field.name === 'Condição de pagamento') {
        setIdCondicaoPagamento(field.id);
      }

      if (field.name === 'Forma de pagamento') {
        setIdFormaPagamento(field.id);
      }
    });
  }, [params.serviceTypeDynamicFields]);

  useEffect(() => {
    const newOrderedFields = reorder(params.serviceSubtypeDynamicFields);
    setReorderedSubtype(newOrderedFields);
    newOrderedFields.forEach((field) => {
      if (field.name === 'Física') {
        setIdFisica(field.id);
      }

      if (field.name === 'Rotina, Alumínio e Enxofre') {
        setidRotina(field.id);
      }

      if (field.name === 'Micro') {
        setidMicro(field.id);
      }

      if (field.name === 'Valor unitário') {
        setIdValorUnitario(field.id);
      }

      if (field.name === 'Valor total') {
        setIdValorTotal(field.id);
      }

      if (field.name === 'Condição de pagamento') {
        setIdCondicaoPagamento(field.id);
      }

      if (field.name === 'Forma de pagamento') {
        setIdFormaPagamento(field.id);
      }
    });
  }, [params.serviceSubtypeDynamicFields]);

  const generateFieldName = (typeOrSubtype, field): string => {
    if (typeOrSubtype === 'subtype') {
      return `subTypeDynamicField${field.id}`;
    }

    return `dynamicField${field.id}`;
  };

  const handleSubmit = (values): void => {
    const dynamicFields = {};
    const subTypeDynamicFields = {};

    Object.keys(values).forEach((v) => {
      if (v.startsWith('sub')) {
        if (values[v] instanceof moment) {
          subTypeDynamicFields[v] = values[v].format(dateFormat);
        } else {
          subTypeDynamicFields[v] = values[v];
        }
      } else {
        if (values[v] instanceof moment) {
          dynamicFields[v] = values[v].format(dateFormat);
        } else {
          dynamicFields[v] = values[v];
        }
      }
    });

    let verifyValorUnitario = formInstance.getFieldValue(`dynamicField${idValorUnitario}`);
    let verifyValorTotal = formInstance.getFieldValue(`dynamicField${idValorTotal}`);
    const verifyCondicaoPagamento = formInstance.getFieldValue(`dynamicField${idCondicaoPagamento}`);
    const verifyFormaPagamento = formInstance.getFieldValue(`dynamicField${idFormaPagamento}`);
    let subTypeVerifyValorUnitario = formInstance.getFieldValue(`subTypeDynamicField${idValorUnitario}`);
    let subTypeVerifyValorTotal = formInstance.getFieldValue(`subTypeDynamicField${idValorTotal}`);
    const subTypeVerifyCondicaoPagamento = formInstance.getFieldValue(`subTypeDynamicField${idCondicaoPagamento}`);
    const subTypeVerifyFormaPagamento = formInstance.getFieldValue(`subTypeDynamicField${idFormaPagamento}`);

    if (verifyValorUnitario == '0,00') {
      verifyValorUnitario = null;
    }

    if (verifyValorTotal == '0,00') {
      verifyValorTotal = null;
    }

    if (subTypeVerifyValorUnitario == '0,00') {
      subTypeVerifyValorUnitario = null;
    }

    if (subTypeVerifyValorTotal == '0,00') {
      subTypeVerifyValorTotal = null;
    }

    if (
      (
        (verifyValorUnitario === undefined || verifyValorUnitario === null || verifyValorUnitario === '')
        && (verifyValorTotal === undefined || verifyValorTotal == null || verifyValorTotal === '')
        && (verifyCondicaoPagamento === undefined || verifyCondicaoPagamento === null || verifyCondicaoPagamento === '')
        && (verifyFormaPagamento === undefined || verifyFormaPagamento === null || verifyFormaPagamento === '')
      ) || (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
        && (verifyCondicaoPagamento !== undefined && verifyCondicaoPagamento !== null && verifyCondicaoPagamento !== '')
        && (verifyFormaPagamento !== undefined && verifyFormaPagamento !== null && verifyFormaPagamento !== '')
      )
    ) {
      if (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
      ) {
        dynamicFields[`dynamicField${idValorUnitario}`] = verifyValorUnitario.replaceAll('.', '').replaceAll(',', '.');
        dynamicFields[`dynamicField${idValorTotal}`] = verifyValorTotal.replaceAll('.', '').replaceAll(',', '.');
      } else {
        dynamicFields[`dynamicField${idValorUnitario}`] = undefined;
        dynamicFields[`dynamicField${idValorTotal}`] = undefined;
      }
    } else {
      notification.warning({
        message: 'AVISO',
        description: 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.',
      });
      return;
    }

    if (
      (
        (subTypeVerifyValorUnitario === undefined || subTypeVerifyValorUnitario === null || subTypeVerifyValorUnitario === '')
        && (subTypeVerifyValorTotal === undefined || subTypeVerifyValorTotal === null || subTypeVerifyValorTotal === '')
        && (subTypeVerifyCondicaoPagamento === undefined || subTypeVerifyCondicaoPagamento === null || subTypeVerifyCondicaoPagamento === '')
        && (subTypeVerifyFormaPagamento === undefined || subTypeVerifyFormaPagamento === null || subTypeVerifyFormaPagamento === '')
      ) || (
        (subTypeVerifyValorUnitario !== undefined && subTypeVerifyValorUnitario !== null && subTypeVerifyValorUnitario !== '')
        && (subTypeVerifyValorTotal !== undefined && subTypeVerifyValorTotal !== null && subTypeVerifyValorTotal !== '')
        && (subTypeVerifyCondicaoPagamento !== undefined && subTypeVerifyCondicaoPagamento !== null && subTypeVerifyCondicaoPagamento !== '')
        && (subTypeVerifyFormaPagamento !== undefined && subTypeVerifyFormaPagamento !== null && subTypeVerifyFormaPagamento !== '')
      )
    ) {
      if (
        (subTypeVerifyValorUnitario !== undefined && subTypeVerifyValorUnitario !== null && subTypeVerifyValorUnitario !== '')
        && (subTypeVerifyValorTotal !== undefined && subTypeVerifyValorTotal !== null && subTypeVerifyValorTotal !== '')
      ) {
        subTypeDynamicFields[`subTypeDynamicField${idValorUnitario}`] = subTypeVerifyValorUnitario.replaceAll('.', '').replaceAll(',', '.');
        subTypeDynamicFields[`subTypeDynamicField${idValorTotal}`] = subTypeVerifyValorTotal.replaceAll('.', '').replaceAll(',', '.');
      } else {
        subTypeDynamicFields[`subTypeDynamicField${idValorUnitario}`] = undefined;
        subTypeDynamicFields[`subTypeDynamicField${idValorTotal}`] = undefined;
      }
    } else {
      notification.warning({
        message: 'AVISO',
        description: 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.',
      });
      return;
    }

    nextPage({ dynamicFields, subTypeDynamicFields });
  };

  const validateDateRange = (
    required,
    rule,
    value,
    initialDate,
    finalDate,
    comparison,
  ): Promise<void> => {
    if (value == null && !required) {
      return Promise.resolve();
    }
    if (!value && required) {
      return Promise.reject(new Error('O campo é obrigatório'));
    }

    if (comparison === 'LESS_EQUAL') {
      if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
        return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
      }
    }

    if (comparison === 'LESS') {
      if (!(moment(value).endOf('day') < moment(finalDate, dateFormat).endOf('day'))) {
        return Promise.reject(new Error(`Insira uma data menor que ${finalDate}`));
      }
    }

    if (comparison === 'GREATER_EQUAL') {
      if (!(moment(value).endOf('day') >= moment(initialDate, dateFormat).endOf('day'))) {
        return Promise.reject(new Error(`Insira uma data maior ou igual que ${initialDate}`));
      }
    }

    if (comparison === 'GREATER') {
      if (!(moment(value).endOf('day') > moment(initialDate, dateFormat).endOf('day'))) {
        return Promise.reject(new Error(`Insira uma data maior que ${initialDate}`));
      }
    }

    if (comparison === 'BETWEEN') {
      if (
        !(moment(value).endOf('day') >= moment(initialDate, dateFormat).endOf('day')
          && moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))
      ) {
        return Promise.reject(new Error(`Insira uma data entre ${initialDate} e ${finalDate}`));
      }
    }

    return Promise.resolve();
  };

  const validateRange = (rule, value, min, max, localComparison): Promise<void> => {
    if (localComparison === 'GREATER') {
      if (value > max || value <= min) {
        // Check for NaN by checking for self-equality
        if (!max) {
          return Promise.reject(new Error(`Por favor, insira um valor maior que ${min}`));
        }
        return Promise.reject(new Error(`Por favor, insira um valor entre ${min} e ${max}`));
      }
    }
    if (value > max || value < min) {
      // Check for NaN by checking for self-equality
      if (!max) {
        return Promise.reject(new Error(`Por favor, insira um valor maior que ${min}`));
      }
      return Promise.reject(new Error(`Por favor, insira um valor entre ${min} e ${max}`));
    }

    return Promise.resolve();
  };

  const testConditional = (referenceValue, comparison, expectedValue, type): any => {
    if (type === 'LONG') { }

    if (type === 'BOOLEAN') { }

    if (type === 'DATE') { }

    if (type === 'STRING') { }

    if (comparison === 'IN') {
      const objExpected = JSON.parse(expectedValue);
      return objExpected.some((obj) => obj === referenceValue);
    }

    if (comparison === 'EQUAL') {
      return referenceValue.toString() === expectedValue.toString();
    }

    if (comparison === 'GREATER') {
      return referenceValue > expectedValue;
    }

    if (comparison === 'GREATER_EQUAL') {
      return referenceValue >= expectedValue;
    }

    if (comparison === 'LESS') {
      return referenceValue < expectedValue;
    }

    if (comparison === 'LESS_EQUAL') {
      return referenceValue <= expectedValue;
    }

    if (comparison === 'BETWEEN') {
      const expectedValueArray = expectedValue.split(';');
      return referenceValue <= expectedValueArray[0] && expectedValueArray[1] <= referenceValue;
    }

    return true;
  };

  const renderSelectField = (typeOrSubtype, field): JSX.Element => {
    const rules = [];

    if (field.required) {
      rules.push({ required: true, message: 'O campo é obrigatório' });
    }

    return (
      <Row gutter={24} key={field.id} className="inline-field">
        <Col span={24}>
          <Form.Item
            label={<span className="field-title-text">{field.name}</span>}
            name={generateFieldName(typeOrSubtype, field)}
            rules={rules}
          >
            <Select>
              {
                field.referenceTableValues.map((v) => (
                  <Select.Option key={v} value={v}>
                    {v}
                  </Select.Option>
                ))
              }
            </Select>
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderAutocomplete = (typeOrSubtype, field): JSX.Element => {
    const rules = [];

    if (field.required) {
      rules.push({ required: true, message: 'O campo é obrigatório' });
    }

    const autocompleteFind = (text): any => (
      field.referenceTableValues
        .filter((v) => v.toLowerCase().includes(text.toLowerCase())).map((v) => (
          { label: v, value: v, key: v }
        ))
    );

    const onSearch = (searchText): any => {
      setAllState((previous) => {
        return ({
          ...previous,
          [`options${field.id}`]: !searchText ? [] : autocompleteFind(searchText),
        });
      });

      return field.referenceTableValues;
    };

    return (
      <Row gutter={24} key={field.id} className="inline-field">
        <Col span={24}>
          <Form.Item
            label={<span className="field-title-text">{field.name}</span>}
            name={generateFieldName(typeOrSubtype, field)}
            rules={rules}
            initialValue={field.value || undefined}
          >
            <AutoComplete
              options={allState[`options${field.id}`] || []}
              onSearch={onSearch}
            />
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderNumberField = (typeOrSubtype, field): JSX.Element => {
    const rules = [];

    if (!arrIdsCodeEstimateFloat.includes(field.idCode)) {
      rules.push({
        type: 'number',
      });
    }

    let min = false;
    let max = false;

    if (field.localExpectedValue) {
      min = Number(field.localExpectedValue.split(';')[0]);
      max = Number(field.localExpectedValue.split(';')[1]);
    }

    if (
      field.idCode === 'GEOFERT-GRID-GRID_TAMANHO_DESEJADO'
      && field.typeValue === 'LONG'
    ) {
      rules.push(
        {
          pattern: /^[\d]{0,19}$/,
          message: 'São permitidos apenas 19 caracteres.',
        },
      );
    }

    if (
      [
        'APLICACAO_CORRETIVOS-AREA_TOTAL-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',
        'APLICACAO_CORRETIVOS-PASTAGEM-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',
        'APLICACAO_CORRETIVOS-LINHA-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',
        'APLICACAO_CORRETIVOS-CARRETA-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',

        'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-INSERIR_ALTURA_CULTURA',
        'SATELITE-TAXA_VARIAVEL_N-INSERIR_ALTURA_CULTURA',
        'SATELITE-MAPA_TCH-INSERIR_ALTURA_CULTURA',
        'SATELITE-LEVANTAMENTO_PRAGAS-INSERIR_ALTURA_CULTURA',
      ].includes(field.idCode)
    ) {
      rules.push(
        {
          required: true,
          message: 'O campo é obrigatório.',
        },
      );
    }

    if (
      [
        'APLICACAO_CORRETIVOS-AREA_TOTAL-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',
        'APLICACAO_CORRETIVOS-PASTAGEM-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',
        'APLICACAO_CORRETIVOS-LINHA-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',
        'APLICACAO_CORRETIVOS-CARRETA-QUANTIDADE_DE_HECTARES_A_SER_REALIZADO_O_SERVICO',

        'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-INSERIR_ALTURA_CULTURA',
        'SATELITE-TAXA_VARIAVEL_N-INSERIR_ALTURA_CULTURA',
        'SATELITE-MAPA_TCH-INSERIR_ALTURA_CULTURA',
        'SATELITE-LEVANTAMENTO_PRAGAS-INSERIR_ALTURA_CULTURA',
      ].includes(field.idCode)
    ) {
      rules.push(
        {
          validator: (rule, value) => {
            if (value < 0) {
              return Promise.reject(new Error('Deve ser um numero maior que zero'));
            }

            return Promise.resolve();
          },
        },
      );
    }

    if (field.required) {
      let validatorMessage = false;
      for (const key in rules) {
        if (rules[key].message === "O campo é obrigatório.") {
          validatorMessage = true;
        }
      }
      rules.push(
        {
          required: true,
          message: validatorMessage ? '' : 'O campo é obrigatório.',
        },
      );
    }

    if (field.localExpectedValue) {
      rules.push(
        {
          validator: (a, b) => validateRange(a, b, min, max, field.localComparison),
        },
      );
    }

    return (
      <Row gutter={24} key={field.id} className="inline-field">
        <Col span={24}>
          {
            arrIdsCodeEstimateFloat.includes(field.idCode) && field.name === 'Valor unitário'
            && (
              <>
                <hr />
                <p className="FillDetails__SessionTitle">Orçamento</p>
              </>
            )
          }

          <Form.Item
            label={<span className="field-title-text">{field.name}</span>}
            name={generateFieldName(typeOrSubtype, field)}
            rules={rules}
          >
            {
              (
                arrIdsCodeEstimateFloat.includes(field.idCode)
                  ? (
                    <CurrencyInput
                      className="ant-input"
                      decimalSeparator=","
                      thousandSeparator="."
                      placeholder="0,00"
                      step={0.01}
                      data-id="1"
                      min={0}
                      style={{ width: '100%' }}
                    />
                  )
                  : (
                    <InputNumber
                      style={{ width: '100%' }}
                      {...(min ? { min, max } : {})}
                      decimalSeparator=","
                      step={field.typeValue === 'DOUBLE' ? 0.01 : 1}
                    />
                  )
              )
            }
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderTextField = (typeOrSubtype, field): JSX.Element => {
    const rules = [];
    let rulesInputEstimateString = {
      find: false,
    };

    if (field.required) {
      rules.push({ required: true, message: 'O campo é obrigatório' });
    }

    if (field.name == 'Qual?') {
      rules.push({ max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' });
    }

    if (arrIdsCodeEstimateString.includes(field.idCode)) {
      rulesInputEstimateString.find = true;
      rulesInputEstimateString.maxLength = 255;
    }

    return (
      <Row gutter={24} key={field.id} className="inline-field">
        <Col span={24}>
          <Form.Item
            label={<span className="field-title-text">{field.name}</span>}
            name={generateFieldName(typeOrSubtype, field)}
            rules={rules}
          >
            {
              rulesInputEstimateString.find === true
                ? <Input style={{ width: '100%' }} maxLength={rulesInputEstimateString.maxLength} />
                : <Input style={{ width: '100%' }} />
            }
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderNonInputInformativeText = (typeOrSubtype, field): JSX.Element => {
    let fieldName = '';
    const untreatedName = field.name;

    if (field.name) {
      fieldName = untreatedName.replaceAll("\n", '<br/>');
    }

    return (
      <Row gutter={24} key={field.id} className="inline-field">
        <Col span={24}>
          <Form.Item>
            {
              untreatedName.includes("\n")
                ? (
                  <p
                    className="FillDetails__NonInputInformativeText"
                    dangerouslySetInnerHTML={{ __html: fieldName }}
                  />
                )
                : (
                  <p className="FillDetails__NonInputInformativeText">
                    {fieldName}
                  </p>
                )
            }
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderDateField = (typeOrSubtype, field): JSX.Element => {
    const rules = [];

    let initialDate = null;
    let finalDate = null;

    if (field.localExpectedValue) {
      const convertDateString = (d): string => {
        if (d === 'TODAY') {
          return moment().format('DD/MM/YYYY');
        }

        return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY');
      };

      if (field.localComparison === 'GREATER_EQUAL' || field.localComparison === 'GREATER') {
        initialDate = convertDateString(field.localExpectedValue);
      }

      if (field.localComparison === 'LESS_EQUAL' || field.localComparison === 'LESS') {
        finalDate = convertDateString(field.localExpectedValue);
      }

      if (field.localComparison === 'BETWEEN') {
        initialDate = convertDateString(field.localExpectedValue.split(';')[0]);
        finalDate = convertDateString(field.localExpectedValue.split(';')[1]);
      }
    }

    if (field.localExpectedValue) {
      rules.push(
        {
          validator: (a, b) => validateDateRange(
            field.required, a, b, initialDate, finalDate, field.localComparison,
          ),
        },
      );
    }
    if (field.required) {
      rules.push(
        {
          required: true,
          message: 'O campo é obrigatório',
        },
      );
    }

    return (
      <Row gutter={24} key={field.id} className="inline-field">
        <Col span={24}>
          <Form.Item
            label={<span className="field-title-text">{field.name}</span>}
            name={generateFieldName(typeOrSubtype, field)}
            rules={rules}
          >
            <DatePicker
              style={{ width: '100%' }}
              locale={locale}
              format={dateFormat}
            />
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderCheckField = (typeOrSubtype, field): JSX.Element => {
    const rules = [];

    if (field.required) {
      rules.push({ required: true, message: 'O campo é obrigatório' });
    }

    if (field.name === 'Física') {
      rules.push({ validator: validateLayer20 });
    }

    return (
      <Row gutter={24} key={field.id}>
        <Col>
          {
            field.idCode.includes('PULVERIZACAO') && (
              <div style={{ marginBottom: '10px' }}>
                Selecione serviços opcionais à sua solicitação:
              </div>
            )
          }
          <Form.Item
            name={generateFieldName(typeOrSubtype, field)}
            initialValue={false}
            valuePropName="checked"
            rules={rules}
          >
            <Checkbox
              className="field-title-text"
            >
              {field.name}
            </Checkbox>
          </Form.Item>
        </Col>
        {
          field.idCode.includes('CURVAS_EMBUTIDAS') && (
            <Col>
              <div className="shape-list-info">
                <Tooltip title={toolTipMessage}>
                  <InfoCircleTwoTone style={{ color: '#faad14', fontSize: '22px', paddingRight: '8px' }} />
                </Tooltip>
              </div>
            </Col>
          )
        }
      </Row>
    );
  };

  const renderDynamicField = (typeOrSubtype, field): JSX.Element => {
    let actualField;

    switch (true) {
      case (field != null && field.referenceTableValues.length > 0):
        actualField = field.id === 1
          ? renderAutocomplete(typeOrSubtype, field)
          : renderSelectField(typeOrSubtype, field);
        break;

      case (field != null && field.typeValue === 'LONG'):
      case (field != null && field.typeValue === 'DOUBLE'):
        actualField = renderNumberField(typeOrSubtype, field);
        break;

      case (field != null && field.typeValue === 'DATE'):
        actualField = renderDateField(typeOrSubtype, field);
        break;

      case (field != null && field.typeValue === 'BOOLEAN'):
        actualField = renderCheckField(typeOrSubtype, field);
        break;

      case (field != null && field.typeValue == null):
        // mostrar caixa com o texto do campo "name"
        actualField = renderNonInputInformativeText(typeOrSubtype, field);
        break;

      default:
        actualField = renderTextField(typeOrSubtype, field);
        break;
    }

    return (
      <React.Fragment key={field.id}>
        {
          field.conditionFieldId
            ? (
              <Form.Item
                shouldUpdate
                noStyle
              >
                {
                  (formInstanceParameter): any => {
                    const allFieldsHelper = formInstanceParameter.getFieldsValue();

                    const referenceFieldName = Object
                      .keys(allFieldsHelper)
                      .find((element) => element.endsWith(`ield${field.conditionFieldId}`));
                    const referenceValue = formInstanceParameter.getFieldValue(referenceFieldName);

                    if (
                      !referenceValue
                      || !testConditional(
                        referenceValue,
                        field.conditionComparison,
                        field.conditionExpectedValue,
                        field.type,
                      )
                    ) {
                      return null;
                    }

                    return actualField;
                  }
                }
              </Form.Item>
            ) : actualField
        }
      </React.Fragment>
    );
  };

  return (
    <div className="FillDetails">
      <Row gutter={24}>
        <Col xs={{ span: 24 }} lg={{ span: 12 }}>
          <Form
            scrollToFirstError
            layout="vertical"
            form={formInstance}
            onFinish={handleSubmit}
            onFinishFailed={
              (errorInfo): void => {
                console.log('onFinishFailed', errorInfo);
              }
            }
          >
            {
              reordered[0] != null
              && reordered.map((v) => {
                return renderDynamicField('type', v);
              })
            }

            {
              reorderedSubtype.map((v) => {
                return renderDynamicField('subtype', v);
              })
            }
          </Form>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 12 }}>
          <SelectedLands
            talhoesSelecionados={params.talhoesSelecionados}
            removeSelectedField={removeSelectedField}
          />
          {
            isCurrentPage
            && <GeoMapSummary params={params} />
          }
        </Col>
      </Row>

      <div className="controls-container">
        <Button
          className="btn-previus-step"
          onClick={
            (): void => {
              previousPage();
            }
          }
        >
          <ArrowLeftIcon />
          voltar
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          onClick={
            (eventt): void => {
              eventt.preventDefault();
              formInstance.submit();
            }
          }
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

FillDetails.propTypes = {
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  isCurrentPage: PropTypes.bool.isRequired,
  removeSelectedField: PropTypes.func.isRequired,

  params: PropTypes.shape({
    selectedService: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),

    selectedType: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),

    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.any).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.any),
    service: PropTypes.string,

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};

FillDetails.defaultProps = {};

export default FillDetails;
